const DRAFT_KEY_PREFIX = 'draft:';

export type DraftApiClient = {
  get: <T>(path: string) => Promise<T>;
  patch: <T>(path: string, body?: unknown) => Promise<T>;
};

export type ConversationInputDraftVersion = {
  id: string;
  conversation_id?: string | null;
  content: string;
  created_at: string;
  updated_at: string;
};

export type ConversationInputDraft = {
  content: string;
  updated_at?: string | null;
  version_id?: string | null;
  versions?: ConversationInputDraftVersion[];
};

export function saveDraft(conversationId: string, value: string) {
  const key = DRAFT_KEY_PREFIX + conversationId;
  if (value) {
    sessionStorage.setItem(key, value);
  } else {
    sessionStorage.removeItem(key);
  }
}

export function loadDraft(conversationId: string): string {
  return sessionStorage.getItem(DRAFT_KEY_PREFIX + conversationId) ?? '';
}

export function clearDraft(conversationId: string) {
  sessionStorage.removeItem(DRAFT_KEY_PREFIX + conversationId);
}

export async function loadServerDraft(apiClient: DraftApiClient, conversationId: string) {
  return apiClient.get<ConversationInputDraft>(`/api/conversations/${conversationId}/draft`);
}

export async function saveServerDraft(
  apiClient: DraftApiClient,
  conversationId: string,
  value: string,
  versionId?: string | null
) {
  return apiClient.patch<ConversationInputDraft>(`/api/conversations/${conversationId}/draft`, {
    content: value,
    ...(versionId ? { version_id: versionId } : {})
  });
}

export async function clearServerDraft(apiClient: DraftApiClient, conversationId: string) {
  return apiClient.patch<ConversationInputDraft>(`/api/conversations/${conversationId}/draft`, {
    clear: true
  });
}
